module.exports = __webpack_public_path__ + "static/media/location.0664b571.png";